import React from 'react';
import {connect} from 'react-redux';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { SSelect } from '@avalara/skylab-sdk/react';

const log = new Logger('SINGLE_VATNUMBER_SELECTOR', LOG_LEVELS.DEBUG);

export class SingleVATNumberSelector extends React.Component {

    selectionCheckedHandlerFactory(fieldName) {
        return (event) => {
            log.debug('selectionCheckedHandlerFactory(%s): %s, ', fieldName, event);
            log.debug('selectionCheckedHandlerFactory(%s): oldValue: %s, newValue: %s  ', fieldName, this.props[fieldName], event.detail.item?.value);
            let selection = {};
            selection[fieldName] = event.detail.item?.value !== '' ? event.detail.item?.value : undefined;
            this.props.selectionHandler(selection);
        }
    }

    render() {
        log.debug('render(): ', this.props);
        return (
            <fieldset>
                <label className="mr20"><LanguageStringResolver string='Liabilities_VATNumber'/></label>
                <SSelect
                    inputId="vatnumber-single-select"
                    name="vatNumbers"
                    onS-select={this.selectionCheckedHandlerFactory(this.props.fieldName).bind(this)}
                    optionsList={[
                        { 
                            label: 'Select VAT Number', 
                            value: '', 
                            selected: !this.props.selectedVATNumberId || this.props.selectedVATNumberId === ''
                        },
                        ...((this.props.VATNumberList || []).map((vatnumber) => ({
                            label: vatnumber,
                            value: vatnumber,
                            selected: this.props.selectedVATNumberId === vatnumber
                        })))
                    ]}
                    multiple={false}
                    showSelectionCount={false}
                />
            </fieldset>
        )
    }
}




// Wrap the component to inject state into it
export default (SingleVATNumberSelector);